<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="htp02">
<h2 class="halfTitlePageTitle" style="text-indent: 0%;"><span class="bold">Hungry Girl<br/> 200 under 200</span></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312556174_htp02.vue?05ff41a3